import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MastermodulePageRoutingModule } from './mastermodule-routing.module';
import { MastermodulePage } from './mastermodule.page';
import { NavbarComponent } from '../navbar/navbar.component';
import { CollectionAppNavbarComponent } from '../collection-app-navbar/collection-app-navbar.component';
import {Mod0104PageModule} from './mod0104/mod0104.module';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MastermodulePageRoutingModule,
    Mod0104PageModule
  ],
  declarations: [MastermodulePage,NavbarComponent,CollectionAppNavbarComponent]
})
export class MastermodulePageModule {}
